import css from 'styled-jsx/css';
import { screen } from '../variables';

const priceCSS = css`
  .prices-container {
    padding: 0 15px;
  }

  .price-card-list {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }

  @media (min-width: ${screen.smMin}) {
    .prices-container {
      width: 750px;
      margin-right: auto;
      margin-left: auto;
      padding-left: 15px;
      padding-right: 15px;
    }

    .price-card-list {
      padding: 0 15px;
    }
  }

  @media (min-width: ${screen.mdMin}) {
    .price-card-list {
      padding: 0;
    }
    .prices-container {
      width: 970px;
    }
  }

  @media (min-width: ${screen.lgMin}) {
    .prices-container {
      width: 1170px;
    }
  }

  @media (max-width: 320px) {
    .prices-container {
      padding: 0 5px;
    }
  }
`;

export default priceCSS;
